import styled from "styled-components";

export const TableStyle = styled.div` & { 
    table {
        tbody {
            tr {
                :last-child {
                    td {
                        border-top: 5px double black;
                        font-weight: bold;     
                    }        
                }
                td:not(:first-child) {
                    text-align: center;
                    min-width: 210px;
                }
                td:first-child {
                    min-width: 300px;
                }
            }
        }

        thead {
            tr {
                th:not(:first-child) {
                    text-align: center;
                }

                th:first-child {
                    width: 300px;
                }
            }
        }
    }
}`;
